module.exports = __webpack_public_path__ + "img/Feuerwehranhänger.8ec3a9e5.svg";